// XHR + upload.onprogress で進捗を出しつつ S3 pre-signed PUT を投げる。
// fetch では body 進捗が取れないため XHR を使う。
export function putWithProgress(
  url: string,
  file: File,
  onProgress: (pct: number) => void,
  options?: { signal?: AbortSignal },
): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', url);
    xhr.setRequestHeader('Content-Type', file.type || 'video/mp4');
    xhr.upload.onprogress = (e) => {
      // 一部のブラウザ (Firefox の古い版など) は e.total=0 を送ってくる → NaN 防止
      if (e.lengthComputable && e.total > 0) {
        onProgress(Math.round((e.loaded / e.total) * 100));
      }
    };
    xhr.onload = () =>
      xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`S3 ${xhr.status}`));
    xhr.onerror = () => reject(new Error('upload failed'));
    xhr.onabort = () => reject(new Error('aborted'));

    if (options?.signal) {
      if (options.signal.aborted) {
        xhr.abort();
        reject(new Error('aborted'));
        return;
      }
      options.signal.addEventListener('abort', () => xhr.abort(), { once: true });
    }

    xhr.send(file);
  });
}
